module.exports = __webpack_public_path__ + "static/media/auto-parts-ab.8a87c1ed.jpg";